import axios from 'axios'

const tumBasvurular = async (data=null) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/basvuru/get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data: data,
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err
        });
    return response;
};

export default tumBasvurular;